// src/components/PhoneBooking.js
import React from 'react';
import { useSalon } from '../context/SalonContext';
import './PhoneBooking.css';

const defaultPhone = "06 41 30 78 72";

function PhoneBooking() {
  const { salonInfos } = useSalon();
  const salonPhoneNumber = salonInfos?.phone || defaultPhone;
  const cleanPhone = salonPhoneNumber.replace(/\s/g, '').replace(/\./g, '');

  return (
    <div className="phone-booking-content">
      <h2 className="phone-booking-title">Réservez par téléphone</h2>
      <p className="phone-booking-text">
        Pour toute demande de rendez-vous ou pour discuter de vos envies,
        <br />
        n'hésitez pas à nous appeler directement :
      </p>
      <a
        href={`tel:${cleanPhone}`}
        className="phone-booking-number"
        aria-label={`Appeler le ${salonPhoneNumber}`}
      >
        {salonPhoneNumber}
      </a>
      <p className="phone-booking-availability">
        Nous avons hâte d'échanger avec vous et de fixer le moment idéal pour prendre soin de vous.
      </p>
      <p className="phone-booking-note">
        Si nous sommes en pleine création capillaire, laissez-nous un message avec vos coordonnées,
        et nous vous recontacterons avec plaisir dès que possible !
      </p>
    </div>
  );
}

export default PhoneBooking;